import { QESSelect } from "@app/shared/qes-standards";
import { GainsPercentEnum } from "@app/projects/servicing-provider/types";
import { translatePercentGains } from "@app/projects/servicing-provider/ServicingProviderHelpers";
import { JSX } from "react";

interface GainsPercentFilterProps {
  containerClassName?: string;
  gainsPercent: GainsPercentEnum;
  hideLabel?: boolean;
  setGainsPercent: (gainsPercent: GainsPercentEnum) => void;
  testId: string;
}

const GainsPercentFilter = (props: GainsPercentFilterProps): JSX.Element => {
  return (
    <QESSelect
      containerClassName={props.containerClassName}
      hideLabel={props.hideLabel}
      label="% Gains"
      onChange={(e) => props.setGainsPercent(parseInt(e.target.value))}
      value={props.gainsPercent || ""}
      testId={props.testId}
    >
      {Object.values(GainsPercentEnum).filter(x => !!translatePercentGains(x as GainsPercentEnum)).map((g, index) => (
        <option
          key={index}
          value={g}
        >
          {translatePercentGains(g as GainsPercentEnum)}
        </option>
      ))}
    </QESSelect>
  )
}

export default GainsPercentFilter;
